import React from "react";
import { observer } from "mobx-react";
import { IBrowserWindowSize } from "@fidget/common/models/browserWindowSize";
import styles from "./cobrowsingIframe.css";
import { useStore } from "../../models";

interface Props {
  size: IBrowserWindowSize;
}

export const CobrowsingIframe = observer(({ size }: Props) => {
  const iframeContainer = React.createRef<HTMLDivElement>();
  const iframe = React.createRef<HTMLIFrameElement>();
  const { cobrowsingStore } = useStore();

  return (
    <div
      className={styles["iframe-container"]}
      style={{
        width: `${size.width}px`,
        height: `${size.height}px`
      }}
      ref={iframeContainer}
    >
      <iframe
        src={cobrowsingStore.cobrowsingSessionUrl}
        scrolling={"auto"}
        ref={iframe}
        sandbox={"allow-popups allow-scripts allow-same-origin"}
      />
    </div>
  );
});
